// extracted by mini-css-extract-plugin
export default {"root":"ShareIcon_root__eV+Ht"};